import { render, staticRenderFns } from "./EditFileForm.vue?vue&type=template&id=4e47096d&scoped=true&"
import script from "./EditFileForm.vue?vue&type=script&lang=js&"
export * from "./EditFileForm.vue?vue&type=script&lang=js&"
import style0 from "./EditFileForm.vue?vue&type=style&index=0&id=4e47096d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e47096d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e47096d')) {
      api.createRecord('4e47096d', component.options)
    } else {
      api.reload('4e47096d', component.options)
    }
    module.hot.accept("./EditFileForm.vue?vue&type=template&id=4e47096d&scoped=true&", function () {
      api.rerender('4e47096d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/components/EditFileForm.vue"
export default component.exports